import { Form, Formik } from 'formik'
import { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import * as Yup from 'yup'
import { DisplayImage } from '../../widgets/components/General/DisplayImage'
import { SelectInput } from '../../widgets/components/Input/SelectInput'
import { Link } from 'react-router-dom'
import { getAllColumnsFromRoundIdIU, getAllInvestorUsers } from '../core/_requests'
import { getAddToCRMData, getSingleInvestorUser } from '../../investor-database/core/_requests'
import { toast } from 'react-toastify'
import Select from 'react-select'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { errorMessage } from '../../profile/core/_constants'
import { useAuth } from '../../auth'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../hooks/gtmHelpers'
import { ToolTipUIForModal } from '../../widgets/components/UI/ToolTipUIForModal'

export const AddInvestorModal = ({
  addInvestorModalShow,
  setAddInvestorModalShow,
  allRounds,
  allInvestors,
  setGetAllColumns,
  activeRound,
  columnDetails,
  refreshActiveRound,
  isInvestorDB,
  investorId,
  investorUserId,
  getInvestors,
  onSearchChange,
}: any) => {
  const [imgName, setimgName] = useState<string | undefined>()
  const [loading, setLoading] = useState(false)
  const [dynamicRoundOptions, setDynamicRoundOptions] = useState<any>()
  const [selectedRoundId, setSelectedRoundId] = useState<number | null>()
  const [investorUser, setInvestorUser] = useState<any>([])
  const [investorUserPresent, setInvestorUserPresent] = useState<any>([])
  const [selectedInvestorId, setSelectedInvestorId] = useState<number | null>(null)
  const [selectedInvestorUserId, setSelectedInvestorUserId] = useState<number | null>(null)
  const [dynamicColumnsFromRoundOptions, setDynamicColumnsFromRoundOptions] = useState<any>()
  const [dynamicInvestorsOptions, setDynamicInvestorsOptions] = useState<any>()
  const [isSearching, setIsSearching] = useState<boolean>(false)
  const { formatMessage } = useIntl()
  const { setShowBillingModal, currentUser, companyId } = useAuth()

  const initialValues = {
    investorId: investorId || null,
    investorUserId: investorUserId || null,
    roundId: activeRound,
    columnId: columnDetails ? columnDetails.columnId : null,
  }

  const addInvestorSchema = Yup.object().shape({
    investorId: Yup.string()
      .required(formatMessage({ id: 'Investor Name is required' }))
      .nullable(),
    investorUserId: Yup.string()
      .required(formatMessage({ id: 'InvestorUser Name is required' }))
      .nullable(),
    roundId: Yup.string()
      .required(formatMessage({ id: 'Round Name is required' }))
      .nullable(),
    columnId: Yup.string()
      .required(formatMessage({ id: 'Column is required' }))
      .nullable(),
  })

  useEffect(() => {
    if (addInvestorModalShow === false) {
      setInvestorUser([])
    }
  }, [addInvestorModalShow])

  //need to add validation otherwise done.
  const onSubmit = async (values: any) => {
    try {
      setLoading(true)
      values.investorId = +values.investorId
      values.roundId = +values.roundId
      if (values.columnId !== undefined) {
        values.columnId = +values.columnId
      }
      const {
        data: { success, errors },
      } = await getAddToCRMData(companyId!, values)
      if (success) {
        if (refreshActiveRound) {
          refreshActiveRound()
        }
        if (getInvestors) {
          getInvestors()
        }
        toast.success(formatMessage({ id: 'Investor contact Added successfully' }))
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.CRMAddInvestorContactSuccessful,
            action: 'normal',
            metadata: {
              user_id: currentUser?.userId,
              email: currentUser?.email,
              company_id: companyId,
              round_id: +values.roundId,
              investor_id: +values.investorId,
              column_id: +values.columnId,
            },
          },
        })
        if (isInvestorDB) {
          setAddInvestorModalShow(false)
        } else {
          const {
            data: { success, data: allColumns },
          } = await getAllColumnsFromRoundIdIU(selectedRoundId!)
          if (success) {
            setGetAllColumns(allColumns)
            setimgName(undefined)
            setAddInvestorModalShow(false)
          } else {
            setimgName(undefined)
          }
        }
      } else if (errors) {
        setimgName(undefined)
        errors.forEach((error: string) => {
          if (
            error === errorMessage.UPGRADE_BILLING_PLAN_LIMIT_EXCEEDED ||
            error === errorMessage.UPGRADE_BILLING_PLAN_FEATURE
          ) {
            setShowBillingModal(true)
            toast.error(formatMessage({ id: error }), { autoClose: false })
          } else {
            toast.error(formatMessage({ id: error }))
          }
        })
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.CRMAddInvestorContactFailed,
            action: 'normal',
            metadata: {
              user_id: currentUser?.userId,
              email: currentUser?.email,
              company_id: companyId,
              round_id: +values.roundId,
              investor_id: +values.investorId,
              column_id: +values.columnId,
              error: errors[0],
            },
          },
        })
      }
    } catch (error) {
      setimgName(undefined)
      console.log(error)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.CRMAddInvestorContactFailed,
          action: 'normal',
          metadata: {
            user_id: currentUser?.userId,
            email: currentUser?.email,
            company_id: companyId,
            round_id: +values.roundId,
            investor_id: +values.investorId,
            column_id: +values.columnId,
            error: error,
          },
        },
      })
    } finally {
      setLoading(false)
    }
  }

  //set Investor Options done
  useEffect(() => {
    if (allInvestors) {
      let investors: any = []
      investors = allInvestors.map((investor: any) => {
        return {
          id: investor.investorId,
          label: investor.name,
          value: investor.investorId,
        }
      })
      setDynamicInvestorsOptions(investors)
    }
  }, [allInvestors])

  //set Round Options done
  useEffect(() => {
    if (allRounds) {
      let rounds: any = []
      rounds = allRounds.map((round: any) => {
        return { id: round.roundId, label: round.roundName, value: round.roundId }
      })
      setDynamicRoundOptions(rounds)
    }
  }, [allRounds])

  //done
  useEffect(() => {
    const getColumnsFromRoundIdApi = async () => {
      try {
        const {
          data: { success, data: allColumns },
        } = await getAllColumnsFromRoundIdIU(selectedRoundId!)
        if (success) {
          let columns: any = []
          let alreadyPresentInvestorUser: any = []

          allColumns.forEach((column: any) => {
            if (column.status !== '0' && column.status !== '1') {
              columns.push({
                id: column.columnId,
                name: column.columnName,
                value: column.columnId,
              })
            }
            alreadyPresentInvestorUser.push(...column.investorUsers)
          })
          setDynamicColumnsFromRoundOptions(columns)
          setInvestorUserPresent([...alreadyPresentInvestorUser])
        }
      } catch (error) {
        console.log(error)
      }
    }
    if (selectedRoundId) {
      if (addInvestorModalShow === true) {
        getColumnsFromRoundIdApi()
      }
    }
  }, [selectedRoundId, addInvestorModalShow])

  //done
  const fetchInvestorUserFromInvestorId = async (investorId: number) => {
    setIsSearching(true)
    const {
      data: { data: investorUsers, success },
    } = await getAllInvestorUsers(investorId, activeRound)
    if (success) {
      const investorUserData = investorUsers
        .filter(
          (investorUser: any) =>
            !investorUserPresent.some(
              (presentElement: any) => presentElement.investorUserId === investorUser.investorUserId
            )
        )
        .map((investorUser: { name: string; investorUserId: number }) => {
          return { label: investorUser.name, value: investorUser.investorUserId }
        })
      setInvestorUser(investorUserData)
      setimgName(undefined)
    }
    setIsSearching(false)
  }
  useEffect(() => {
    if (selectedInvestorId && addInvestorModalShow === true) {
      fetchInvestorUserFromInvestorId(selectedInvestorId)
    }
  }, [selectedInvestorId, addInvestorModalShow, investorUserPresent]) // eslint-disable-line react-hooks/exhaustive-deps

  // using this to get Img for InvestorUser
  useEffect(() => {
    const getSingleInvestorUserdata = async () => {
      if (!!selectedInvestorUserId) {
        const {
          data: { data: values, success },
        } = await getSingleInvestorUser(+selectedInvestorUserId, +activeRound)
        if (success) {
          if (values.fileId !== null) {
            setimgName(values.file?.name)
          } else {
            setimgName(undefined)
          }
        }
      }
    }
    if (selectedInvestorUserId) {
      getSingleInvestorUserdata()
    }
  }, [selectedInvestorUserId]) // eslint-disable-line react-hooks/exhaustive-deps

  const DropdownIndicator = () => {
    return (
      <div className='me-3'>
        <img src={toAbsoluteUrl('/media/icons/investor/search.svg')} alt='search' />
      </div>
    )
  }
  const customStyles = {
    placeholder: (provided: any, state: any) => ({
      ...provided,
      fontSize: 13,
      fontWeight: 500,
    }),
    input: (provided: any, state: any) => ({
      ...provided,
      fontSize: 13,
      padding: 0,
    }),
  }

  return (
    <>
      <Modal
        size='lg'
        show={addInvestorModalShow}
        onHide={() => {
          setAddInvestorModalShow(false)
          setimgName(undefined)
        }}
        aria-labelledby='contained-modal-title-vcenter'
        centered
      >
        <Formik
          initialValues={initialValues}
          validationSchema={addInvestorSchema}
          onSubmit={onSubmit}
        >
          {(formik) => {
            setSelectedRoundId(formik.values.roundId)
            setSelectedInvestorId(formik.values.investorId)
            setSelectedInvestorUserId(formik.values.investorUserId)

            return (
              <Form>
                <Modal.Header closeButton>
                  <h2>{formatMessage({ id: 'Add Contact' })}</h2>
                </Modal.Header>
                <Modal.Body className='mx-5'>
                  <div className=' mb-5 mt-0'>
                    <div>
                      <p className='font-size-16 text-muted mb-5'>
                        {formatMessage({
                          id: 'You can also add investors directly from our ',
                        })}{' '}
                        <span className='font-size-16'>
                          <Link className='fw-bold' to='/investor-database/all-investor'>
                            {formatMessage({ id: 'Investor Database' })}
                          </Link>
                        </span>
                      </p>
                    </div>
                    <div className='d-flex flex-column flex-md-row col-12 justify-content-md-between'>
                      <div className='d-flex flex-column align-items-start'>
                        <p className='font-size-13 mb-3'>{formatMessage({ id: 'Logo' })}</p>
                        <div className='img_Card'>
                          <DisplayImage
                            imgName={imgName}
                            height='120px'
                            width='120px'
                            alt='profile'
                            className='shadow-sm'
                          />
                        </div>
                      </div>

                      <div className='col-md-7 col-12 mt-md-0 mt-6'>
                        <div className='highlight-multi-select font-size-12 text-bold searchable-select w-100 mb-6'>
                          <div className='d-flex'>
                            <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                              {formatMessage({ id: 'Investor Name' })}*{' '}
                              <ToolTipUIForModal
                                tooltipText={formatMessage({
                                  id: 'GLOBAL.TOOLTIP.ADDINVESTORMODAL.INVESTOR_NAME',
                                })}
                              />
                            </label>
                          </div>
                          <Select
                            name={'investorId'}
                            value={dynamicInvestorsOptions?.find(
                              (option: any) => option.value === formik.values['investorId']
                            )}
                            onChange={(option) => {
                              formik.setFieldValue('investorId', option?.value)
                              formik.setFieldValue('investorUserId', null)
                            }}
                            onBlur={formik.handleBlur}
                            options={dynamicInvestorsOptions}
                            placeholder={formatMessage({ id: 'Enter Investor or firm Name' })}
                            components={{ DropdownIndicator }}
                            onInputChange={onSearchChange}
                            styles={customStyles}
                            isSearchable={true}
                            classNamePrefix='react-select'
                            isDisabled={isInvestorDB || isInvestorDB}

                          />
                        </div>

                        <div className='col-12 col-lg-6 col-xl-6 col-md-6 w-100 mb-6 '>
                          <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                            {formatMessage({ id: 'Select Investor Contact Person' })}*{' '}
                            <ToolTipUIForModal
                              tooltipText={formatMessage({
                                id: 'GLOBAL.TOOLTIP.ADD_INVESTORUSER_MODAL.INVESTOR_USER',
                              })}
                            />
                          </label>

                          <Select
                            name={'investorUserId'}
                            classNamePrefix='react-select'
                            components={{ DropdownIndicator }}
                            placeholder={formatMessage({ id: 'Type few letters to search' })}
                            styles={customStyles}
                            // isSearchable={true}
                            isSearchable={!isSearching}
                            value={
                              investorUser?.find(
                                (option: any) => option.value === formik.values['investorUserId']
                              ) || null
                            }
                            options={investorUser}
                            onBlur={formik.handleBlur}
                            onChange={(option: any) =>
                              formik.setFieldValue('investorUserId', option?.value)
                            }
                            isLoading={isSearching}
                            isDisabled={
                              isInvestorDB ? (isInvestorDB && investorUserId) || false : isSearching
                            }
                          />
                        </div>

                        <div className='col-12 col-lg-6 col-xl-6 col-md-6 w-100 mb-6'>
                          <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                            {formatMessage({ id: 'Round Name' })}*{' '}
                            <ToolTipUIForModal
                              tooltipText={formatMessage({
                                id: 'GLOBAL.TOOLTIP.ADD_INVESTORUSER_MODAL.ROUND',
                              })}
                            />
                          </label>

                          <Select
                            name={'roundId'}
                            classNamePrefix='react-select'
                            components={{ DropdownIndicator }}
                            placeholder={formatMessage({ id: 'Select Round' })}
                            styles={customStyles}
                            isSearchable={true}
                            value={dynamicRoundOptions?.find(
                              (option: any) => option.value === formik.values['roundId']
                            )}
                            options={dynamicRoundOptions}
                            onBlur={formik.handleBlur}
                            onChange={(option) => {
                              formik.setFieldValue('roundId', option?.value)
                              formik.setFieldValue('columnId', null)
                            }}
                            isDisabled={(isInvestorDB && investorUserId) || false}
                          />
                        </div>

                        <SelectInput
                          label={formatMessage({ id: 'Column Name' })}
                          fieldName={'columnId'}
                          formik={formik}
                          placeholder={formatMessage({ id: 'Select Column' })}
                          margin='me-0'
                          toolTipText={formatMessage({ id: 'GLOBAL.TOOLTIP.PEOPLE.NAME' })}
                          options={dynamicColumnsFromRoundOptions}
                          isTooltipForModal={true}
                        />
                      </div>
                    </div>
                  </div>
                  <div className='d-md-flex gap-3 w-100 justify-content-md-end'>
                    <button
                      type='button'
                      className='btn btn-bg-light rounded w-100 w-md-auto font-size-13'
                      onClick={() => {
                        setAddInvestorModalShow(false)
                        setimgName(undefined)
                      }}
                    >
                      {formatMessage({ id: 'Cancel' })}
                    </button>
                    <button
                      className='btn btn-primary rounded w-100 w-md-auto font-size-13 mt-md-auto mt-2 '
                      disabled={loading || formik.isSubmitting || !formik.isValid}
                    >
                      {!loading && (
                        <span className='indicator-label font-size-13 p-0'>
                          {formatMessage({ id: 'Add Contact' })}
                        </span>
                      )}
                      {loading && (
                        <span className='indicator-label font-size-13 p-0'>
                          {formatMessage({ id: 'Please wait...' })}
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                      )}
                    </button>
                  </div>
                </Modal.Body>
              </Form>
            )
          }}
        </Formik>
      </Modal>
    </>
  )
}
